module.exports = __webpack_public_path__ + "static/media/phone-cleaner.afbfbd64.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/phone-cleaner.png
// module id = 287
// module chunks = 0